import { memo } from 'react';

import { NumberInput } from '@/modules/common/components/inputs';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';

type Props = {
  value: number;
  disabled: boolean;
  onChange: (value: number) => void;
};

const DistanceInputComponent = ({ value, disabled, onChange }: Props) => (
  <PropertiesLabel i18nkey='interface:reference.properties.dimension' labelRatio={50}>
    <NumberInput
      value={value}
      unit='mm'
      name='Dimension'
      minValue={0}
      disabled={disabled}
      onChange={onChange}
    />
  </PropertiesLabel>
);

export const DistanceInput = memo(DistanceInputComponent);
